import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/core/helper/common.service';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-layout-login',
  templateUrl: './login-layout.component.html',
  host:{}
})

export class loginLayoutComponent implements OnInit {

  constructor(private fb: UntypedFormBuilder, private commonService : CommonService) { }

   // Loader | Temporary
   showLoader() {
    document.getElementById('showLoader').classList.add('d-none');
    document.getElementById('hideLoader').classList.remove('d-none');
    document.getElementById('pageLoader').classList.remove('d-none');
  }
  hideLoader() {
    document.getElementById('hideLoader').classList.add('d-none');
    document.getElementById('showLoader').classList.remove('d-none');
    document.getElementById('pageLoader').classList.add('d-none');
  }


  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian'}
  ];

  // Login Carousel
  introSliderOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 2000,
    autoHeight:false,
    navText: ['<i class="material-icons pmd-sm">arrow_back</i>', '<i class="material-icons pmd-sm">arrow_forward</i>'],
    responsive: {
      0: {
        items: 1,
        autoHeight:true,
      },
      400: {
        items: 1,
        autoHeight:true,
      },
      740: {
        items: 1,
        autoHeight:true,
      },
      940: {
        items: 1
      }
    },
    nav: false
  }

  ngOnInit() {

  }

  changeLang(){
    this.commonService.changeLanguage(this.language)
  }

}
